var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-drawer",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        placement: "right",
        closable: false,
        visible: _vm.visible,
      },
      on: { close: _vm.close },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules },
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "describe",
                    label: "//描述",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入//描述" },
                    model: {
                      value: _vm.model.describe,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "describe", $$v)
                      },
                      expression: "model.describe",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "editionUrl",
                    label:
                      "//apk、wgt包下载地址或者应用市场地址  安卓应用市场 market://details?id=xxxx 苹果store itms-apps://itunes.apple.com/cn/app/xxxxxx",
                  },
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder:
                        "请输入//apk、wgt包下载地址或者应用市场地址  安卓应用市场 market://details?id=xxxx 苹果store itms-apps://itunes.apple.com/cn/app/xxxxxx",
                    },
                    model: {
                      value: _vm.model.editionUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "editionUrl", $$v)
                      },
                      expression: "model.editionUrl",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "editionForce",
                    label: "//是否强制更新 0代表否 1代表是",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.editionForce,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "editionForce", $$v)
                      },
                      expression: "model.editionForce",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "packageType",
                    label:
                      "//0是整包升级（apk或者appstore或者安卓应用市场） 1是wgt升级",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.packageType,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "packageType", $$v)
                      },
                      expression: "model.packageType",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "editionIssue",
                    label:
                      "//是否发行  0否 1是 为了控制上架应用市场审核时不能弹出热更新框",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.editionIssue,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "editionIssue", $$v)
                      },
                      expression: "model.editionIssue",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "editionNumber",
                    label:
                      "//版本号 最重要的manifest里的版本号 （检查更新主要以服务器返回的edition_number版本号是否大于当前app的版本号来实现是否更新）",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.editionNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "editionNumber", $$v)
                      },
                      expression: "model.editionNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "editionName",
                    label: "// 版本名称 manifest里的版本名称",
                  },
                },
                [
                  _c("a-input", {
                    attrs: {
                      placeholder: "请输入// 版本名称 manifest里的版本名称",
                    },
                    model: {
                      value: _vm.model.editionName,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "editionName", $$v)
                      },
                      expression: "model.editionName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "editionSilence",
                    label: "// 是否静默更新 0代表否 1代表是",
                  },
                },
                [
                  _c("a-input-number", {
                    model: {
                      value: _vm.model.editionSilence,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "editionSilence", $$v)
                      },
                      expression: "model.editionSilence",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "drawer-bootom-button" },
        [
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleOk } },
            [_vm._v("确定")]
          ),
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleCancel } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }